import { Trans } from '@lingui/react/macro';
import { Button } from 'src/components/ui';
import CustomBadge from '../../CustomBadge';
import Loader from '../../Loader';
import { FileStage, UploadStatus } from './types';
import { STATUS_COLOR, STATUS_ICON } from './util';
import Icon from 'src/components/Icon';

export function StatusBadge({ status }: { status: UploadStatus }) {
  const label = ({
    'Not Uploaded': <Trans>Not Uploaded</Trans>,
    Uploaded: <Trans>Uploaded</Trans>,
    Partial: <Trans>Partial Upload</Trans>,
    Error: <Trans>Error</Trans>,
    Done: <Trans>Done</Trans>,
    'Nothing to Report': <Trans>Nothing to Report</Trans>,
  } as Record<UploadStatus, React.ReactNode>)[status];
  return (
    <CustomBadge color={STATUS_COLOR[status] ?? 'secondary'} pill>
      <Icon icon={STATUS_ICON[status]} className="mr-1" />
      {label}
    </CustomBadge>
  );
}

export function DownloadIconBtn({ onClick, title }: { onClick: () => void; title: string }) {
  return (
    <Button color="link" size="sm" className="p-0 ml-1 align-baseline" title={title} onClick={onClick}>
      <Icon icon="Download" />
    </Button>
  );
}

export function ValidationIndicator({ stage }: { stage: FileStage }) {
  if (stage.validationState === 'pending') {
    return (
      <span className="text-muted small ml-2 inline-flex justify-center items-center gap-1">
        <Loader spinner sm inline size={16} />
        <Trans>Validating…</Trans>
      </span>
    );
  }

  if (stage.validationState === 'valid') {
    return (
      <span className="text-success small ml-2 inline-flex justify-center items-center gap-1">
        <Icon icon="CheckCircle" /> <Trans>Valid</Trans>
      </span>
    );
  }

  if (stage.validationState === 'notice') {
    return (
      <span className="text-warning small ml-2 inline-flex justify-center items-center gap-1">
        <Icon icon="Warning" /> <Trans>Uploaded with Notices</Trans>
      </span>
    );
  }

  if (stage.validationState === 'error') {
    return (
      <span className="text-danger small ml-2 inline-flex justify-center items-center gap-1">
        <Icon icon="XCircle" /> {stage.errorMessage ?? <Trans>Validation failed</Trans>}
      </span>
    );
  }

  return null;
}
